/* These constants are important for building the submitted event to match dashboards & stuff */
export var EVENTS_API_DIVISION = 'commerce';
export var EVENTS_API_DOMAIN = 'dotcom';
export var EVENTS_API_PLATFORM = 'cloud';
export var EVENTS_API_VIEW_NAME = 'view';